module.exports = __webpack_public_path__ + "slide0.131c460849d91036105a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/private/home/slide0.jpg
// module id = ./src/assets/images/private/home/slide0.jpg
// module chunks = main